import React, { useEffect, useState, useContext } from "react";
import { Link, Navigate, useNavigate, useLocation } from "react-router-dom";
import { AppSettings } from "../config/app-settings.js";
import Joi from "joi";
import { useSelector, useDispatch } from "react-redux";
import { authActions } from "../_store";
import "react-notifications-component/dist/theme.css";
import { ReactNotifications } from "react-notifications-component";
import "react-notifications-component/dist/theme.css"; // Import the CSS
import NotificationService from "../ui/ui-modal-notification.js";
import registerSchema from "../validation/registerSchema.js";
import Logo from "../assets/dr_inmate_logo.png";
import background from "../../src/assets/images/banner-img-new.jpg";
import useFullPageLoader from "../hooks/useFullPageLoader";
import { EventLog } from "../components/common/EventLog/EventLog.jsx";
import { storeCurrentRoute } from "../utils/routeTracker.js";

function ForgotPassword() {
  const context = useContext(AppSettings);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { emailSaveResponse } = useSelector((state) => state.auth);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [activeMail, setActiveMail] = useState({
    email: "",
    userType: "publicuser",
    forgotType: "",
  });
  const [errorMessage, setErrorMessage] = useState({});
  const [errors, setErrors] = useState({});
  const [selectedOption, setSelectedOption] = useState("2");

  const handleChanges = () => {
    const infoMessage = "Forget Password Page - click Back button";
    const redirectURL = "public/Login";
    const Response = " --- ";
    const Status = " Redirected into login page ";
    EventLog(dispatch, infoMessage, redirectURL, Response, Status)
    navigate("/public/Login"); // Use navigate for redirection
    storeCurrentRoute("/public/Login");
  };

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setActiveMail((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  // JOI Validation
  const validate = async () => {
    try {
      await registerSchema.validateAsync(activeMail, { abortEarly: false });
      return {};
    } catch (err) {
      const validationErrors = {};
      err.details.forEach((error) => {
        if (error.path[0] === "email") {
          validationErrors[error.path[0]] = error.message;
        }
      });
      return validationErrors;
    }
  };

  // Forgot Password - submit function
  const handleSubmit = async (event) => {
    ;
    event.preventDefault();
    const validationErrors = await validate();

    setErrors(validationErrors);
    if (Object.keys(validationErrors).length === 0) {
      showLoader();
      if (selectedOption === "2") {
        activeMail.forgotType = selectedOption;
        dispatch(
          authActions.SendUsernameForget({
            email: activeMail.email,
            userType: "publicuser",
            forgotType: activeMail.forgotType,
          })
        ).then((x) => {
          const infoMessage = "Forget UserName - Clicked Submit Button ( Email - " + activeMail.email + " ) ";
          const redirectURL = "/public/Login";
          const Response = JSON.stringify(x.payload);
          const Status = "Please check your mail Id and try again.";
          EventLog(dispatch, infoMessage, redirectURL, Response, Status)
        })
      } else if (selectedOption === "1") {
        activeMail.forgotType = selectedOption;
        dispatch(
          authActions.SendUsernameForget({
            email: activeMail.email,
            userType: "publicuser",
            forgotType: activeMail.forgotType,
          })
        ).then((x) => {
          const infoMessage = "Forget Password - Clicked Submit Button ( Email - " + activeMail.email + " ) ";
          const redirectURL = "/public/Login";
          const Response = JSON.stringify(x.payload);
          const Status = "Please check your mail Id and try again.";
          EventLog(dispatch, infoMessage, redirectURL, Response, Status)
        })
      }
    }
  };

  // Handle reset action
  const handleReset = () => {
    setActiveMail({ email: "" });
    setErrors({});
    setActiveMail((prev) => ({
      ...prev, // Spread the previous state to preserve other properties if any
      email: "", // Reset the email property to an empty string
    }));

    // Clear the specific email error from the errors object
    setErrors((prevErrors) => ({
      ...prevErrors, // Preserve other errors if necessary
      email: null,  // Clear the email error specifically
    }));
    const infoMessage = "Forget Password Page - Clear Input Fields";
    const redirectURL = " --- ";
    const Response = " --- ";
    const Status = " --- ";
    EventLog(dispatch, infoMessage, redirectURL, Response, Status)
  };

  // Handle radio button change
  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
  };

  // Function used to redirect to signup page
  const handleSignUp = (event) => {
    const infoMessage = "Forget Password Page - Clicked into Sign Up Button";
    const redirectURL = "public/Register";
    const Response = " --- ";
    const Status = "Redirected into Sign Up page ";
    EventLog(dispatch, infoMessage, redirectURL, Response, Status)
    navigate("/public/Register");
    storeCurrentRoute("/public/Register");
  };

  // Resend activation response
  useEffect(() => {

    hideLoader();
    if (selectedOption === "1") {
      if (emailSaveResponse.IsValidUser === 1) {
        NotificationService({
          title: "Success",
          message: "username sent to your registered E-mail",
          type: "success", // can be 'success', 'danger', 'info', 'warning'
        });
        navigate("/public/Login");
        storeCurrentRoute("/public/Login");
      }
      if (emailSaveResponse.IsValidUser === -2) {
        dispatch(authActions.clearEmailResponse());
        NotificationService({
          title: "Warning",
          message:
            "Please check your mail ID and try again.",
          type: "warning", // can be 'success', 'danger', 'info', 'warning'
        });
      }
    }
    else {
      if (emailSaveResponse.IsValidUser === 1) {

        NotificationService({
          title: "Success",
          message: "username sent to your registered E-mail",
          type: "success", // can be 'success', 'danger', 'info', 'warning'
        });
        navigate("/public/Login");
        storeCurrentRoute("/public/Login");
      }
      if (emailSaveResponse.IsValidUser === -2) {
        dispatch(authActions.clearEmailResponse());
        NotificationService({
          title: "Warning",
          message:
            "Please enter the E-mail you used to sign up for your Inmate Inbox account. We ll send Username to the registered E-mail.",
          type: "warning", // can be 'success', 'danger', 'info', 'warning'
        });
      }
    }

  }, [emailSaveResponse]);
  return (
    <>
      <div className="register register-with-news-feed">
        <ReactNotifications />
        <div className="news-feed">
          <div
            className="news-image"
            style={{
              backgroundImage: `url(${background})`,
            }}
          ></div>
          <div className="news-caption">
            <h1 className="text-white font-xl">
              <b>INMATE INBOX</b>
            </h1>
            <p className="font-size-20 max-width-80">
              Send & Receive Secure Electronic Messages With Your{" "}
              <span className="default-color">Loved</span> Ones. There’s no
              better way to stay connected with your loved one or friend than
              real time messages.
            </p>
          </div>
        </div>
        <div className="register-container">
          <div className="login-header mb-20px">
            <div className="brand">
              <div
                className="d-flex align-items-center mt-4"
                style={{ justifyContent: "center" }}
              >
                <img src={Logo} className="login-logo" alt=""></img>
              </div>
            </div>
          </div>
          <div className="position-absolute top-0 end-0 p-4">
            <span
              className="text-dark fs-12 text-decoration-none"
            >
              <span className="font-size-15">New User <b className="text-danger text-underline" onClick={handleSignUp} style={{ cursor: "pointer" }}>Sign Up</b></span>
            </span>
          </div>
          <div className="register-content">
            <form onSubmit={handleSubmit} className="fs-13px">
              <h2 class="title-default mb-2">
                Forgot <span id="forgetTitle">{selectedOption === "2" && "Username?"}
                  {selectedOption === "1" && "Password?"}
                </span>
              </h2>
              <p class="font-size-16">
                Please enter the e-mail you used to sign up for your Inmate Inbox
                account.

                {selectedOption === "2" &&
                  "We'll send Username to the registered e-mail."}
                {selectedOption === "1" &&
                  "We'll send Password reset link to the registered e-mail."}
              </p>
              <div class="row">
                <div class="col-md-9 pt-2">
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="inlineRadio1"
                      name="inlineRadio"
                      value="2"
                      checked={selectedOption === "2"}
                      onChange={handleOptionChange}
                      //onClick={handleReset}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault();
                          handleSubmit(e);
                        }
                      }}
                    />
                    <label class="form-check-label" for="inlineRadio1">
                      Username
                    </label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="customRadio2"
                      name="inlineRadio"
                      value="1"
                      checked={selectedOption === "1"} // This checks the radio button
                      onChange={handleOptionChange}
                      onClick={handleReset}
                    />
                    <label class="form-check-label" for="customRadio2">
                      Password
                    </label>
                  </div>
                </div>
              </div>

              <div className="mb-3">
                {/* <label className="mb-2">
                  {" "}
                  <span className="text-danger"></span>
                </label> */}
                <div className="text-danger fw-700 fs-6 mb-20px mt-1">
                  {errorMessage["UserName"] && errorMessage["UserName"]}
                </div>
                <input
                  type="text"
                  className={`form-control mb-5px fs-5 fw-normal ${errors.email ? "input-error" : ""
                    }`}
                  // className="form-control fs-13px"
                  placeholder="E-mail"
                  id="email"
                  name="email"
                  value={activeMail.email} // Bind input value to state
                  onChange={handleChange} // Handle change with handleChange function
                />
                {errors.email && (
                  <div className="text-danger fw-700 fs-6 mt-1">
                    {errors.email}
                  </div>
                )}
              </div>
              <div className="mb-4">

                <button
                  type="submit"
                  className="btn btn-theme me-2 font-size-14 mb-2"
                >
                  <i class="fa-solid fa-check me-1"></i>
                  Submit
                </button>

                <button type="button" className="btn btn-grey me-2 font-size-14 mb-2" onClick={handleReset}>
                  <i className="fa-solid fa-arrow-rotate-left me-1"></i>
                  Reset
                </button>


                {/* Back to Login Text */}

                <span
                  className="font-size-15 d-block mt-3 mb-40px pb-40px " // Using Bootstrap's "danger" color
                >
                  Back to <b className="text-danger text-underline font-size-15" onClick={handleChanges} style={{ cursor: 'pointer' }}> Login</b>
                </span>
              </div>
              <hr className="bg-gray-600 opacity-2 " />
              <p className="text-center text-gray-600">
                &copy; Inmate Inbox All Right Reserved {new Date().getFullYear()}
              </p>
            </form>
          </div>
        </div>
        {loader}
      </div>
    </>
  );
}

export default React.memo(ForgotPassword);
